module.exports = __webpack_public_path__ + "8b97786a2579115408d93d6e48c4923f.png";